import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import BACKEND from "../../utils/backend";

export const makePayment = createAsyncThunk(
  "/payment/makePayment",
  async (payload, thunkAPI) => {
    try {
      return new BACKEND().send({
        type: "post",
        to: "/payments/makepayment",
        payload,
        useAlert: true,
      });
    } catch (error) {
      console.error(error);
      return thunkAPI.rejectWithValue("Payment recording failed");
    }
  }
);

export const makeBulkPayment = createAsyncThunk(
  "/payment/makeBulkPayment",
  async (payload, thunkAPI) => {
    try {
      // Mock the bulk payment for now as requested
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            success: true,
            message: "Bulk payment recorded successfully",
            data: payload,
          });
        }, 1000);
      });
    } catch (error) {
      console.error(error);
      return thunkAPI.rejectWithValue("Bulk payment recording failed");
    }
  }
);

const paymentSlice = createSlice({
  name: "payment",
  initialState: {
    loading: false,
    error: null,
    modal: {
      confirmation: false,
      bulkConfirmation: false,
      loading: false,
    },
  },
  reducers: {
    openModal: (state, action) => {
      state.modal[action.payload] = true;
    },
    closeModal: (state, action) => {
      state.modal[action.payload] = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(makePayment.pending, (state) => {
        state.loading = true;
        state.modal.loading = true;
      })
      .addCase(makePayment.fulfilled, (state) => {
        state.loading = false;
        state.modal.loading = false;
        state.modal.confirmation = false;
      })
      .addCase(makePayment.rejected, (state, action) => {
        state.loading = false;
        state.modal.loading = false;
        state.error = action.payload;
      })
      .addCase(makeBulkPayment.pending, (state) => {
        state.loading = true;
        state.modal.loading = true;
      })
      .addCase(makeBulkPayment.fulfilled, (state) => {
        state.loading = false;
        state.modal.loading = false;
        state.modal.bulkConfirmation = false;
      })
      .addCase(makeBulkPayment.rejected, (state, action) => {
        state.loading = false;
        state.modal.loading = false;
        state.error = action.payload;
      });
  },
});

export const getPaymentData = (state) => state.payment;
export const { openModal, closeModal } = paymentSlice.actions;
export default paymentSlice.reducer;
